import { SVGProps, Ref, forwardRef } from 'react';

export const FacebookGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.848 14.95a7.001 7.001 0 1 0-2.54-.156V10.14H4.865V8h1.445v-.924c0-2.383 1.078-3.486 3.416-3.486.442 0 1.207.087 1.52.174v1.94a9 9 0 0 0-.809-.025c-1.148 0-1.59.434-1.59 1.565V8h2.287l-.392 2.14H8.848z"
                fill="#919191"
            />
            <path
                d="M6.309 14.794V10.14H4.864V8h1.445v-.924c0-2.383 1.078-3.486 3.416-3.486.442 0 1.207.087 1.52.174v1.94a9 9 0 0 0-.809-.025c-1.148 0-1.59.434-1.59 1.565V8h2.287l-.392 2.14H8.848v4.81a7.1 7.1 0 0 1-2.54-.156"
                fill="#E2E2E2"
            />
        </g>
    </svg>
));
FacebookGrayscaleSize16Glyph.displayName = 'FacebookGrayscaleSize16Glyph';
